import HomeHeading from "./homeHeading";

export default HomeHeading;